"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormikExtended = _interopRequireDefault(require("@sprinx/react-forms/FormikExtended"));

var _useAuthenticate = _interopRequireDefault(require("@sprinx/react-auth/useAuthenticate"));

var _LoginFormInner = _interopRequireDefault(require("./LoginFormInner"));

var initialValues = {
  password: '',
  username: ''
};
var validationSchema = {
  username: {
    type: 'string',
    empty: false,
    min: 3
  },
  password: {
    type: 'string',
    empty: false,
    min: 3
  } // forgettenPassword: { type: 'email' },

};

function LoginForm(_ref) {
  var handleClose = _ref.onClose,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["onClose"]);
  var authenticate = (0, _useAuthenticate.default)();

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isLoginError = _React$useState2[0],
      setLoginError = _React$useState2[1];

  var handleSubmitForm = _react.default.useCallback(function (credentials) {
    if (isLoginError) setLoginError(false);
    authenticate(null, {
      credentials: credentials
    }).then(function () {
      return handleClose();
    }).catch(function () {
      return setLoginError(true);
    });
  }, [authenticate, isLoginError, handleClose]);

  return /*#__PURE__*/_react.default.createElement(_FormikExtended.default, (0, _extends2.default)({}, rest, {
    initialValues: initialValues,
    validationSchema: validationSchema,
    validationFastest: true,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: handleSubmitForm
  }), function (frmProps) {
    return /*#__PURE__*/_react.default.createElement(_LoginFormInner.default, (0, _extends2.default)({}, frmProps, {
      isLoginError: isLoginError,
      onClose: handleClose
    }));
  });
}

process.env.NODE_ENV !== "production" ? LoginForm.propTypes = {
  onClose: _propTypes.default.func.isRequired
} : void 0;
LoginForm.defaultProps = {};
var _default = LoginForm;
exports.default = _default;